import * as React from "react";
import { forwardRef } from "react";
const LogoSbpSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fill: "#5B57A2", d: "m3.274 5.79 2.61 4.761v2.905l-2.607 4.753z" }),
    React.createElement("path", { fill: "#D90751", d: "m13.293 8.817 2.445-1.53 5.003-.005-7.448 4.66z" }),
    React.createElement("path", { fill: "#FAB718", d: "m13.28 5.76.013 6.306-2.615-1.641V1z" }),
    React.createElement("path", { fill: "#ED6F26", d: "m20.742 7.283-5.004.005-2.459-1.527L10.678 1z" }),
    React.createElement("path", { fill: "#63B22F", d: "M13.293 18.235v-3.059l-2.615-1.61.001 9.435z" }),
    React.createElement("path", { fill: "#1487C9", d: "m15.732 16.719-9.848-6.168-2.61-4.762 17.457 10.924z" }),
    React.createElement("path", { fill: "#017F36", d: "m10.679 23 2.613-4.765 2.439-1.517 5-.006z" }),
    React.createElement("path", { fill: "#984995", d: "m3.277 18.209 7.422-4.642-2.495-1.563-2.32 1.452z" }));
const ForwardRef = forwardRef(LogoSbpSVG);
export default ForwardRef;
//# sourceMappingURL=LogoSbp.js.map